import { render, staticRenderFns } from "./VehicleCustomisationComponent.vue?vue&type=template&id=e2332308"
import script from "./VehicleCustomisationComponent.vue?vue&type=script&lang=ts"
export * from "./VehicleCustomisationComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports